import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/Auth';
import { ResponseSchema } from './types';
import { Education } from '@/types/education';
import Axios from '@/lib/axiosConfig';

type GetEducationByIdRes = ResponseSchema<Education>;

export const useGetEducationById = (
  educationId: string, 
  queryOptions?: Partial<{
    staleTime: number;
    refetchOnMount: boolean;
    refetchOnWindowFocus: boolean;
    enabled: boolean;
  }>
) => {
  const { getAPIRequestTokenHeaders } = useAuth();

  const query = useQuery<GetEducationByIdRes>({
    queryKey: ['educations', educationId],
    queryFn: () =>
      Axios.get(`/educations/${educationId}`, {
        headers: getAPIRequestTokenHeaders(),
      }).then(res => res.data),
    enabled: !!educationId,
    staleTime: queryOptions?.staleTime,
    refetchOnMount: queryOptions?.refetchOnMount,
    refetchOnWindowFocus: queryOptions?.refetchOnWindowFocus,
  });

  return query;
};